// ClassSelect.js
import React, { useState, useEffect } from 'react';
import AppStrings from '../config/appstring';

const ExportSelect = ({ value, onChange }) => {
  const [classOptions, setClassOptions] = useState([]); // To store class options fetched from the API

//   useEffect(() => {
//     const fetchClassDetails = async () => {
//       try {
//         const response = await fetch(AppStrings.BusStopList);
//         const data = await response.json(); // Assuming the response is in JSON format

//         if (data.success === 200 && Array.isArray(data.data)) {
//           setClassOptions(data.data); // Set the class options
//         } else {
//           console.error('Invalid data format received:', data);
//         }
//       } catch (error) {
//         console.error('Error fetching class details:', error);
//       }
//     };

//     fetchClassDetails();
//   }, []); // Empty dependency array to fetch data once on component mount

  return (
    <div>
        
          <div class="coolinput">
      {/* <label for="input" class="text">Area List</label> */}
      <select  style={{ height: '40px' }}
        name="PLACE"
        value={value} // Controlled component
        onChange={onChange} // Passing onChange to parent
        className="input"
        autoComplete="off"
      >
        <option value="">SELECT</option>
        <option value="excel">Excel</option>
    <option value="pdf">PDF</option>
      </select>
      </div>
    </div>
  );
};

export default ExportSelect;




